import { useElements, CardNumberElement } from '@stripe/react-stripe-js';
import { authHttp } from '../http';
import { CAPTCHA_KEY, getCaptchaToken } from '../captchaHelper';

export const useCardFormListeners = (updateValidation) => {
  const elements = useElements();

  return {
    handleNumberChange: ({ complete, empty, error }) => {
      updateValidation((v) => ({ ...v, card: { complete, empty, error } }));
      if (complete) {
        elements.getElement('cardExpiry').focus();
      }
    },
    handleExpirationChange: ({ complete, empty, error }) => {
      updateValidation((v) => ({ ...v, expiration: { complete, empty, error } }));
      if (complete) {
        elements.getElement('cardCvc').focus();
      }
    },
    handleCSCChange: ({ complete, empty, error }) => {
      updateValidation((v) => ({ ...v, cvc: { complete, empty, error } }));
    }
  };
};

const processMethodUpdate = (stripe, paymentMethod, paymentMethodType) => getCaptchaToken().then((token) => authHttp('/v1/store/stripe/payment-setup-intent/create', 'POST', {
  stripe_payment_method_id: paymentMethod.id,
  product_id: 'product_id', // whatever but not an empty string
  recaptcha_token: token,
  recaptcha_site_key: CAPTCHA_KEY,
}))
  .then(({
    requires_action: requiresAction,
    stripe_payment_setup_intent_id: setupIntentId,
    stripe_payment_setup_intent_client_secret: setupIntentSecret
  }) => {
    if (requiresAction) {
      return stripe.confirmCardSetup(setupIntentSecret, { payment_method: paymentMethod.id })
        .then(({ error, setupIntent }) => {
          if (error) {
            throw error;
          }

          return setupIntent.id;
        });
    }

    return setupIntentId;
  })
  .then((setupIntendId) => authHttp('/v1/store/chargebee/subscription/update-payment', 'POST', {
    stripe_payment_intent_id: setupIntendId,
    payment_method: paymentMethodType
  }));

export const onGooglePaySubmit = (stripe, paymentMethod, onComplete) => processMethodUpdate(
  stripe,
  paymentMethod,
  'google_pay'
).then(() => onComplete('success'));
export const onApplePaySubmit = (stripe, paymentMethod, onComplete) => processMethodUpdate(
  stripe,
  paymentMethod,
  'apple_pay'
).then(() => onComplete('success'));

export const onChangeMethodCardSubmit = (elements, stripe) => {
  const cardElement = elements.getElement(CardNumberElement);

  return stripe.createPaymentMethod({
    type: 'card',
    card: cardElement,
  })
    .then((res) => {
      if (res.error) {
        throw res;
      }

      return res.paymentMethod;
    })
    .then((paymentMethod) => processMethodUpdate(stripe, paymentMethod, 'card'));
};

export const onPayPalMethodApprove = (paypalToken) => authHttp('/v1/store/chargebee/subscription/update-payment', 'POST', {
  paypal_express_payment_token: paypalToken,
  payment_method: 'paypal_express_checkout'
});
